import axios from 'axios';

import { MODIFIER_HUB_URL_INVENTORY_V1 } from '../constants';
import reject from '../reject';

export function getModifiersList(params?) {
  return axios
    .get(MODIFIER_HUB_URL_INVENTORY_V1, { params, withCredentials: true })
    .catch(reject);
}

export function postModifierHub(data) {
  return axios
    .post(MODIFIER_HUB_URL_INVENTORY_V1, data, {
      withCredentials: true,
    })
    .catch(reject);
}

export function getModifierDetail(id, params?) {
  return axios
    .get(`${MODIFIER_HUB_URL_INVENTORY_V1}/${id}`, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function putItemById(id, data) {
  return axios
    .put(`${MODIFIER_HUB_URL_INVENTORY_V1}/${id}`, data, {
      withCredentials: true,
    })
    .catch(reject);
}

export function deleteModifierHub(id, params?) {
  return axios
    .delete(`${MODIFIER_HUB_URL_INVENTORY_V1}/${id}`, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function postApplyToItems(id, data) {
  return axios
    .post(`${MODIFIER_HUB_URL_INVENTORY_V1}/${id}/apply`, data)
    .catch(reject);
}

export function postApplyToAllItem(id, data?) {
  return axios
    .post(`${MODIFIER_HUB_URL_INVENTORY_V1}/${id}/apply-all-item`, data)
    .catch(reject);
}
